import React, { useState, useEffect } from 'react'
import VerClientes from './VerClientes.js'
import SubirUsuario from './SubirUsuario.js'
import VerCliente from './VerCliente.js'

// import EditarUsuario from './EditarUsuario.js'
import axios from 'axios'
import Eliminar from '../componentes/Eliminar.js'
import Header from '../componentes/Header.js';
import Paginacion from '../componentes/Paginacion.js'
import moment from 'moment'

const FormateaFecha = (dato) => {
	let fecha = moment(dato).format('YYYY-MM-DD')
	return fecha
}

const formatoSeparador = (number) => {
	const exp = /(\d)(?=(\d{3})+(?!\d))/g;
	const rep = '$1,';
	return `$${number?.toString().replace(exp, rep)}`;
}

export const convertirAObjetoFiltro = (array, campo) => {
	// Primero convierte a un array con elementos únicos basados en el campo especificado
	let result = Array.from(new Set(array.map(item => item[campo])));
	// Convierte a un objeto con las claves del campo y los valores iguales a las claves
	let objeto = result.reduce((obj, value) => { obj[value] = value; return obj; }, {});
	return objeto;
};

const CrmAdmin = ({ baseUrl, Titulo, cursos, urlPedidos, urlEstados, urlAsesores, urlInteracciones, urlPedidosCliente, urlProductos, urlCampanas }) => {

	//almacena toda la data de categorias 
	const [tituloPag, setTituloPag] = useState(Titulo)
	const [error, setError] = useState({ activo: false })
	const [data, setData] = useState([])
	const [usuarioSelect, setUsuarioSelect] = useState({})
	const [funcion, setFuncion] = useState('cargando')
	const [alerta, setAlerta] = useState(false)

	const [copiaArray, setCopiaArray] = useState([])
	const [busqueda, setBusqueda] = useState('')

	const PAGINACION = 15
	const [dataFiltrado, setDataFiltrado] = useState([])
	const [filteredData, setFilteredData] = useState([]);

	const [columns, setColumnas] = useState([
		{ title: "Estado CRM", field: "estado_crm", render: item => <div className={`estados`} style={{ backgroundColor: item.estado_color }}>{item.estado_crm}</div> },
		{ title: 'COD', field: "id" },
		{ title: 'Inscrip', field: "fecha_ins", render: (item) => FormateaFecha(item.fecha_ins) },
		{ title: 'Nombre', field: "nombre" },
		{ title: 'Usuario', field: "usuario" },
		{ title: 'Teléfono', field: "telefono" },
		{ title: 'Compras', field: "total_pedidos", render: (item) => formatoSeparador(item.total_pedidos) },
		{ title: 'Asesor', field: "asesor" }
	]);

	const RecibeBusqueda = e => {
		setBusqueda(e.target.value)
		filtrar(e.target.value)
	}


	const Filtros = (array) => {
		const estado_crm = convertirAObjetoFiltro(array, 'estado_crm');
		const nombre = convertirAObjetoFiltro(array, 'nombre');
		const asesor = convertirAObjetoFiltro(array, 'asesor');
		const total_pedidos = convertirAObjetoFiltro(array, 'total_pedidos');

		setColumnas(prevColumns => prevColumns.map(column => {
			if (column.field === 'estado_crm') { return { ...column, lookup: estado_crm }; }
			else if (column.field === 'nombre') { return { ...column, lookup: nombre }; }
			else if (column.field === 'asesor') { return { ...column, lookup: asesor }; }
			else if (column.field === 'total_pedidos') { return { ...column, lookup: total_pedidos }; }

			else { return column; }
		}));

	}


	const filtrar = (termino) => {
		let resultado = copiaArray.filter((item) => {
			if (item.nombre.toLowerCase().includes(termino.toLowerCase()) || item.usuario.toLowerCase().includes(termino.toLowerCase())) {
				return item
			}
		})
		setDataFiltrado(resultado)
	}

	const peticionTraeDatos = () => {
		setFuncion("cargando")
		setData([])
		setCopiaArray([])
		setDataFiltrado([])
		setUsuarioSelect({})
		axios.get(baseUrl, { params: { usuario: '1', clave: '1', unico: 'false' } })
			.then(response => {
				setFuncion('ver')
				setData(response.data)
				setCopiaArray(response.data)
				setDataFiltrado(response.data)
				Filtros(response.data)
			}).catch(error => {
				console.log(error)
			})
	}

	//realiza petición que borra de la base de datos por medio de la ID
	const peticionDelete = () => {
		let f = new FormData();
		f.append("METHOD", "DELETE");
		axios.post(baseUrl, f, { params: { id: usuarioSelect.id } })
			.then(response => {
				setData(data.filter(categoria => categoria.id !== usuarioSelect.id))
				setDataFiltrado(dataFiltrado.filter(categoria => categoria.id !== usuarioSelect.id))
				setFuncion('ver')
			}).catch(error => {
				console.log(error)
			})
	}

	//Selecciona categoria para editarla o borrarla 
	const Seleccionar = (objeto, funcion) => e => {
		setFuncion(funcion)
		setUsuarioSelect(objeto)
		if (funcion === 'editar') { setFuncion('editar') }
	}

	//Trae todas las categorias de la api
	useEffect(() => { peticionTraeDatos() }, [])

	useEffect(() => {
		switch (funcion) {
			case 'ver': return setTituloPag('Ver Clientes CRM')
			case 'crear': return setTituloPag('Crear Cliente')
			case 'editar': return setTituloPag('Editar Cliente')
			case 'eliminar': return setTituloPag('Eliminar Cliente')
			default: return setTituloPag('Clientes')
		}
	}, [funcion])

	const ReiniciarPaginacion = () => {
		setDataFiltrado([...data].splice(0, PAGINACION))
		setBusqueda('')
	}

	return (
		<div>
			<Header titulo={tituloPag} botonAgregar={false} Pagina={'Usuarios'} RecibeBusqueda={RecibeBusqueda} resetBusq={ReiniciarPaginacion} setFuncion={setFuncion} funcion={funcion} />

			<div className="row">
				<div className="col-md-12">

					{funcion === 'editar' ?
						<VerCliente
							data={dataFiltrado}
							setData={setDataFiltrado}
							baseUrl={baseUrl}
							setFuncion={setFuncion}
							Cursos={cursos}
							funcion={funcion}
							registroSelect={usuarioSelect}
							dataFiltrado={dataFiltrado}
							setDataFiltrado={setDataFiltrado}
							urlEstados={urlEstados}
							urlAsesores={urlAsesores}
							urlInteracciones={urlInteracciones}
							urlPedidosCliente={urlPedidosCliente}
							urlProductos={urlProductos}
							urlCampanas={urlCampanas}
							peticionTraeDatos={peticionTraeDatos}

						/>
						: null}
					{funcion === 'eliminar' ?
						<Eliminar
							nombre={'Usuario'}
							select={usuarioSelect}
							setFuncion={setFuncion}
							peticionDelete={peticionDelete}
						/>
						: null}
					{funcion === 'cargando' ?
						<div className="loader">Loading...</div>
						: null}
					{funcion === 'ver' ?
						<VerClientes
							data={dataFiltrado}
							seleccionaRegistro={Seleccionar}
							columns={columns}
							setFilteredData={setFilteredData}
						/>
						: null}
					{funcion === 'crear' ?
						<SubirUsuario
							data={data}
							setData={setData}
							baseUrl={baseUrl}
							setFuncion={setFuncion}
							Cursos={cursos}
							funcion={funcion}
							registroSelect={usuarioSelect}
							urlPedidos={urlPedidos}
							dataFiltrado={dataFiltrado}
							setDataFiltrado={setDataFiltrado}
						/>
						: null}
				</div>
			</div>
		</div>
	)
}

export default CrmAdmin